/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useState} from "react";
import { Control, Controller } from "react-hook-form";
import { FormControl, TextField, useTheme, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import ErrorMessage from "../ErrorMessage";
import useResponsive from "@/hooks/useResponsive";
import { getInputStyles } from "./styles";

interface IProp {
  control: Control<any>;
  name: string;
  placeholder: string;
}

const Field: React.FC<IProp> = ({ control, name, placeholder }) => {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);

    return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <FormControl
            component="label"
            error={!!fieldState.error}
            sx={{ position: "relative", width: "100%" }}
          >
            <TextField
              {...field}
              placeholder={placeholder}
              variant="outlined"
              type={name === "password" || name === "confirmPassword" ? (showPassword ? "text" : "password") : "text"}
              inputProps={{
                style: {
                  padding: "12px",
                  fontSize: `${isMobile ? "1rem" : "1.125rem"}`,
                  fontWeight: 500,
                  fontFamily: '"Mulish",sans-serif',
                },
              }}
              sx={getInputStyles(theme)}
              InputProps={
                  name === "password" || name === "confirmPassword" 
                      ? {
                          endAdornment: (
                              <InputAdornment position="end">
                                  <IconButton onClick={togglePasswordVisibility} edge="end">
                                      {showPassword ? <VisibilityOff /> : <Visibility />}
                                  </IconButton>
                              </InputAdornment>
                          ),
                      }
                      : undefined
              }
            />
            {fieldState.error?.message && (
              <ErrorMessage message={fieldState.error.message} />
            )}
          </FormControl>
        );
      }}
    />
  );
};

export default Field;
